import moment from "moment";
import {
  contractStatuses,
  prolongDate,
} from "../../../../../helpers/data-constants";

const useGlobalProlongDeal = ({
  paramReq,
  prolongCalculate = {},
  deals = {},
  status,
  lastPaidDate,
  startDate,
  endDate,
  isExtensionThreeImplementaition
}) => {
  const isExpiredDealStatus = (status) => status === contractStatuses.EXPIRED.param;
  const newProlongDate = isExtensionThreeImplementaition ? prolongDate.crediton.NEW_PROLONG_DATE : prolongDate.visem.NEW_PROLONG_DATE
  const isNewGlobalProlong = moment( startDate || prolongCalculate[0]?.startDate || deals[0]?.startDate).isAfter(newProlongDate);

  const getInitialDateDefaults = (fieldPosition) => {
    const { maxPaidDate } = { ...fieldPosition }
    const maxDate = moment(maxPaidDate).isAfter(moment().add(30, "days"))
      ? moment().add(30, "days")
      : moment(maxPaidDate);

    const minDateDefault = moment().format("YYYY-MM-DD");
    const maxDateDefault = maxDate.format("YYYY-MM-DD");
    return { minDateDefault, maxDateDefault };
  };

  const calculateDateDefault = ({ idx, ...params }) => {
    const listingDeal = { ...paramReq[idx] };
    const paramsWithListing = { ...params, idx, listingDeal };

    return handleDaysLimit(paramsWithListing);
  };

  const handleDaysLimit = ({
    fieldPosition,
  }) => {
    const { minDateDefault, maxDateDefault } = getInitialDateDefaults(fieldPosition);
    let modalExtensionError = {};

    return {
      minDateDefault,
      maxDateDefault,
      modalExtensionError,
    };
  };

  const calculateExtensionDate = (deal) => {
    const currentDate = moment();
    const lastPaidDateValue = deal?.lastPaidDate || lastPaidDate;
    const isExpired = isExpiredDealStatus(deal?.status ?? status);
    const isLastPaidToday =
      lastPaidDateValue && moment(lastPaidDateValue).isSame(currentDate, "day");

    if (isExpired) {
      return isLastPaidToday
        ? moment(lastPaidDateValue).add(1, "days")
        : currentDate;
    }

    if (isLastPaidToday) {
      return moment(deal?.endDate ?? endDate).add(1, "days");
    }

    return currentDate;
  };

  const baseExtensionDate = (deal) =>
    calculateExtensionDate(deal).format("YYYY-MM-DD");

  return { calculateDateDefault, baseExtensionDate, isNewGlobalProlong };
};

export default useGlobalProlongDeal;
